import { createReducer, on } from '@ngrx/store';
import { setProposal } from './proposal.actions';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

const localStorageService = new LocalStorageService();

export interface State {
  proposal; // Proposal; TODO: crear modelo de Proposal
}

export const initialState = localStorageService.get('currentProposal') || {};

export const proposalReducer = createReducer(
  initialState,

  on(setProposal, (state, { proposal }) => ({ ...proposal }))
);
